export default "__VITE_ASSET__CbxB3pkb__"